<template>
  <section>
    <h3 class="education-title">Education</h3>
    <div class="education-column">
      <h4 class="color">GSK College of Information Technologies | Russia</h4>
      <h5>Information Technologies in Economics | 2011</h5>
    </div>
    <div class="education-column">
      <h4 class="color">Charles University of Prague | Czech Republic</h4>
      <h5>Czech Language Course for IT specialists | 2014</h5>
    </div>
    <div class="education-column">
      <h4 class="color">UPCE & MTUSI — Information Technologies</h4>
      <h5>Partially completed | Czech Republic & Russia</h5>
    </div>
  </section>
</template>

<script>
export default {
  name: "ResumeEducation"
};
</script>

<style lang="scss">
section {
  padding-top: 40px;
  line-height: 40px;
  padding-inline: 7vw;
}
.education-title {
  font-size: 1.55rem;
  color: #23415d;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid #23415d;
}

.education-column {
  text-align: left;
  line-height: 20px;
  padding: 10px;
}

.color {
    color: #23415d;
}
</style>